import React, { FC, Fragment, ReactNode } from 'react';

import { Content, DataGridBox, DataGridWrap, Label, Separator } from './DataGrid.styled';

export type DataRecord = {
  label: string | ReactNode;
  content: string | ReactNode | null;
};

type DataGridLoaded = {
  loading?: false;
  dataRows?: number;
  data: DataRecord[];
};

type DataGridLoading = {
  loading: true;
  dataRows?: number;
  data?: DataRecord[];
};

type DataGridProps = DataGridLoading | DataGridLoaded;

export const DataGrid: FC<DataGridProps> = (props) => {
  const { loading, data, dataRows = 6 } = props;

  if (loading) {
    return (
      <DataGridWrap>
        {[...Array(dataRows)].map((_, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <DataGridBox key={`data-grid-box-${idx}`} elements={dataRows}>
            skeleton
          </DataGridBox>
        ))}
      </DataGridWrap>
    );
  }

  return (
    <DataGridWrap>
      {data?.map(({ label, content }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`data-grid-row-${index}`}>
          <DataGridBox elements={data?.length}>
            <Label>{label}</Label>
            <Content>{content || '-'}</Content>
          </DataGridBox>
          {index % 3 === 2 && index !== data.length - 1 && <Separator color="light" />}
        </Fragment>
      ))}
    </DataGridWrap>
  );
};
